import TinyLabel from "components/text/TinyLabel";
import styles from "css/pages/common/nft/NftLabelAndContent.module.css";
import ColorClass from "types/enums/ColorClass";

type Props = {
  children: any;
  className?: string;
  label: string;
  labelColorClass?: ColorClass;
};

export default function NftLabelAndContent({
  children,
  className,
  label,
  labelColorClass = ColorClass.Secondary,
}: Props): JSX.Element {
  return (
    <div className={className}>
      <TinyLabel colorClass={labelColorClass} textTransform="uppercase">
        {label}
      </TinyLabel>
      <div className={styles.content}>{children}</div>
    </div>
  );
}
